
import Vue, { VueConstructor } from "vue";
import webshopSourceAutocomplete from "@/modules/salesOrder/api/webshopSource";
import KSelect from "@/components/crud/fields/KSelect.vue";

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: {
        autocomplete: {
          refresh: () => Promise<unknown>;
        };
      };
    }
  >
).extend({
  name: "WebshopSourceSelect",
  components: { KSelect },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    webshopSources: [] as { code: string | null; name: string }[],
  }),
  watch: {
    clientId: {
      handler() {
        this.getWebshopSource();
      },
      immediate: true,
    },
  },
  methods: {
    async getWebshopSource() {
      const response = await webshopSourceAutocomplete(this.clientId);

      this.webshopSources = [
        {
          name: this.$t("salesOrder.defaultwebshopSourceId") as string,
          code: null,
        },
        ...response.data.data,
      ];
    },
  },
});
